<template>
  <div>
    <div v-for="k in Object.keys(groups).sort()" :key="k" class="group">
      <div class="char">
        {{ k }}
      </div>
      <div class="list">
        <div
          v-for="item in groups[k]"
          :key="item.districtID"
          :class="['district', item.districtID === currentProvinceId ? 'active' : '']"
          @click="selectItem(item)"
        >
          {{ item.districtName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, defineEmits, defineExpose } from 'vue';
import { request } from '../../../api/request';
import type { District, WebBasicBizAddressGetMultiLevelSubListOut } from '../../../api/types';

const provinceList = ref<WebBasicBizAddressGetMultiLevelSubListOut['districtList']>([])
const currentProvinceId = ref('')

const emit = defineEmits(['select'])

const keys = [
  ['A', 'F'],
  ['G'],
  ['H', 'I'],
  ['J', 'R'],
  ['S', 'W'],
  ['X', 'Z']
]

const selectItem = (item) => {
  console.log(item, '省')
  currentProvinceId.value = item.districtID
  emit('select', item)
}

onMounted(async () => {
  const data = await request("web.basicBiz.address.getMultiLevelSubList", {
    districtLevel: 'province'
  })
  provinceList.value = data.districtList || []
})

const groups = computed(() => {
  return keys.reduce((result, k) => {
    const list = provinceList.value.filter(p => {
      return k.length > 1 ? k[0] <= p.initials && k[1] >= p.initials : k[0] === p.initials
    })
    return { ...result, [k.join('-')]: list }
  }, {} as Record<string, District[]>)
})

defineExpose({
  reset: () => currentProvinceId.value = ''
})
</script>

<style scoped>
.group {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
}

.district,
.char {
  white-space: nowrap;
  cursor: pointer;
  font-size: 13px;
  line-height: 20px;

  &:hover {
    color: #7E51E4;
  }
}
.district.active {
  color: #7E51E4;
}

.char {
  width: 32px;
  padding: 5px 0;
  color: #686B75;
  flex-shrink: 0;
}

.district {
  padding: 5px 10px;
  color: #24262B;
}
</style>